<div class="wizard-page">
  <div class="wizard-card">

    <!-- Progress bar -->
    <div class="progress-bar-wrap" *ngIf="step < 4">
      <div class="progress-bar-fill" [style.width.%]="(step / 3) * 100"></div>
    </div>

    <!-- ── Step 1: Choose trade ── -->
    <div *ngIf="step === 1" class="wizard-step">
      <div class="step-header">
        <mat-icon class="step-icon">home_repair_service</mat-icon>
        <h1>What's your trade?</h1>
        <p>Pick the primary service you provide. You can add more services later.</p>
      </div>

      <div class="trade-grid">
        <button *ngFor="let trade of trades"
                class="trade-card"
                [class.selected]="selectedTrade === trade.value"
                (click)="selectTrade(trade.value)"
                type="button">
          <mat-icon class="trade-icon">{{ trade.icon }}</mat-icon>
          <span class="trade-label">{{ trade.label }}</span>
          <span class="trade-desc">{{ trade.description }}</span>
          <mat-icon class="check-icon" *ngIf="selectedTrade === trade.value">check_circle</mat-icon>
        </button>
      </div>

      <div class="step-actions">
        <button mat-raised-button color="primary" [disabled]="!selectedTrade" (click)="nextStep()">
          Continue <mat-icon>arrow_forward</mat-icon>
        </button>
      </div>
    </div>

    <!-- ── Step 2: Profile details ── -->
    <div *ngIf="step === 2" class="wizard-step">
      <div class="step-header">
        <mat-icon class="step-icon">person</mat-icon>
        <h1>Tell customers about yourself</h1>
        <p>This information appears on your public provider profile.</p>
      </div>

      <div class="form-fields">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Service Area</mat-label>
          <input matInput [(ngModel)]="serviceArea" name="serviceArea"
                 placeholder="e.g. Boston, MA; Cambridge, MA; Somerville, MA" />
          <mat-hint>Comma-separated cities or zip codes you serve</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Bio</mat-label>
          <textarea matInput [(ngModel)]="bio" name="bio" rows="4"
                    placeholder="Describe your experience, certifications, and what sets you apart…"></textarea>
          <mat-hint>{{ bio.length }} / 500 characters</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Phone Number</mat-label>
          <input matInput [(ngModel)]="phone" name="phone"
                 placeholder="(555) 000-0000" />
          <mat-icon matSuffix>phone</mat-icon>
        </mat-form-field>
      </div>

      <div class="step-actions">
        <button mat-stroked-button (click)="prevStep()">
          <mat-icon>arrow_back</mat-icon> Back
        </button>
        <button mat-raised-button color="primary"
                [disabled]="!serviceArea.trim()" (click)="nextStep()">
          Continue <mat-icon>arrow_forward</mat-icon>
        </button>
      </div>
    </div>

    <!-- ── Step 3: Review & confirm ── -->
    <div *ngIf="step === 3" class="wizard-step">
      <div class="step-header">
        <mat-icon class="step-icon">fact_check</mat-icon>
        <h1>Review your profile</h1>
        <p>Confirm the details below. You can edit them anytime from your dashboard.</p>
      </div>

      <div class="review-card">
        <div class="review-row">
          <span class="review-label">Trade</span>
          <span class="review-value highlight">{{ selectedTradeLabel }}</span>
        </div>
        <div class="review-row">
          <span class="review-label">Service Area</span>
          <span class="review-value">{{ serviceArea }}</span>
        </div>
        <div class="review-row" *ngIf="bio">
          <span class="review-label">Bio</span>
          <span class="review-value">{{ bio }}</span>
        </div>
        <div class="review-row" *ngIf="phone">
          <span class="review-label">Phone</span>
          <span class="review-value">{{ phone }}</span>
        </div>
      </div>

      <div class="error-msg" *ngIf="errorMessage">{{ errorMessage }}</div>

      <div class="step-actions">
        <button mat-stroked-button (click)="prevStep()" [disabled]="isLoading">
          <mat-icon>arrow_back</mat-icon> Back
        </button>
        <button mat-raised-button color="primary" (click)="submit()" [disabled]="isLoading">
          <mat-icon>check</mat-icon>
          {{ isLoading ? 'Activating…' : 'Become a Provider' }}
        </button>
      </div>
    </div>

    <!-- ── Step 4: Success ── -->
    <div *ngIf="step === 4" class="wizard-step success-step">
      <div class="success-icon-wrap">
        <mat-icon class="success-icon">verified</mat-icon>
      </div>
      <h1>You're a Provider!</h1>
      <p>Your account is active as a <strong>{{ selectedTradeLabel }}</strong>. Start adding your services so customers can find and book you.</p>

      <div class="step-actions">
        <button mat-raised-button color="primary" (click)="goToDashboard()">
          <mat-icon>dashboard</mat-icon> Go to Dashboard
        </button>
      </div>
    </div>

  </div>
</div>
